import get from 'lodash/get';

import { createSelector } from 'reselect';

export const selectRootState = state =>
  get(state, 'managePatientInsurances.getPatientInsurancesList');

export const selectPatientInsurancesList = createSelector(
  selectRootState,
  state => get(state, 'list', []),
);

export const selectPatientInsurancesListIds = createSelector(
  selectPatientInsurancesList,
  list => list.map(item => get(item, 'id')),
);

export const selectIsAdditionalInsurancesEnabled = createSelector(
  selectRootState,
  state => get(state, 'meta.additionalInsurancesEnabled', false),
);

export const selectAdditionalInsurancesMaxNumber = createSelector(
  selectRootState,
  state => get(state, 'meta.additionalInsurancesMaxNumber', 0),
);



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/selectors/get-patient-insurances-list.js